import { useState, useEffect } from 'react';

import { useUser } from '../contexts/user';

export default function PermissionManager({ allowedProjects, allowedEndpoints, children }) {
    const [shouldRender, setShouldRender] = useState(false);
    const { permissions } = useUser();

    useEffect(() => {
        if (allowedProjects || allowedEndpoints) {
            const isSomeProjectAllowed = allowedProjects?.some((project) => permissions.projects.includes(project));
            const isSomeEndpointAllowed = allowedEndpoints?.some((endpoint) => permissions.endpoints.includes(endpoint));

            setShouldRender(isSomeProjectAllowed || isSomeEndpointAllowed);

            return;
        }

        setShouldRender(false);
    }, [allowedEndpoints, allowedProjects, children, permissions]);

    if (!shouldRender) {
        return null;
    }

    return children;
}
